
















import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconArrowSmallRight',
  props: {
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '11.991',
    },
  },
});
